<div class="parquet-import-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Parquet Import</mat-card-title>
      <mat-card-subtitle>
        Import leads from Google Cloud Storage Parquet files to Firestore
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <!-- Emulator Toggle -->
      <div class="emulator-toggle">
        <mat-checkbox [(ngModel)]="useEmulator">
          Use Firestore Emulator
        </mat-checkbox>
      </div>

      <!-- Import All Section -->
      <div class="import-section">
        <h3>Import All Files</h3>
        <p>Import all parquet files from the configured GCS bucket.</p>
        <button
          mat-raised-button
          color="primary"
          (click)="importAll()"
          [disabled]="isImporting"
          >
          <mat-icon>cloud_upload</mat-icon>
          Import All
        </button>
      </div>

      <mat-divider></mat-divider>

      <!-- Import with Prefix Section -->
      <div class="import-section">
        <h3>Import with Prefix</h3>
        <p>Import parquet files filtered by a prefix (e.g., "data/2024/").</p>
        <mat-form-field appearance="outline">
          <mat-label>Prefix (optional)</mat-label>
          <input matInput id="parquet-prefix-input" aria-label="Prefix (optional)" [(ngModel)]="prefix" placeholder="data/2024/" />
        </mat-form-field>
        <div class="button-group">
          <button
            mat-raised-button
            color="primary"
            (click)="importWithPrefix()"
            [disabled]="isImporting"
            >
            <mat-icon>filter_list</mat-icon>
            Import with Prefix
          </button>
          <button
            mat-button
            (click)="loadFileList()"
            [disabled]="isLoadingFiles"
            >
            <mat-icon>refresh</mat-icon>
            Refresh File List
          </button>
        </div>
      </div>

      <mat-divider></mat-divider>

      <!-- File List Section -->
      <div class="import-section">
        <h3>Available Files</h3>
        @if (isLoadingFiles) {
          <div class="loading">
            <mat-spinner diameter="30"></mat-spinner>
            <span>Loading files...</span>
          </div>
        }
        @if (!isLoadingFiles && fileList.length > 0) {
          <mat-list>
            @for (file of fileList; track file) {
              <mat-list-item
                [class.selected]="selectedFile === file"
                (click)="selectedFile = file"
                (keydown)="onFileItemKeyDown($event, file)"
                tabindex="0"
                role="button"
                [attr.aria-label]="'Select file: ' + file"
                >
                <mat-icon matListItemIcon>description</mat-icon>
                <div matListItemTitle>{{ file }}</div>
              </mat-list-item>
            }
          </mat-list>
        }
        @if (!isLoadingFiles && fileList.length === 0) {
          <p>
            No parquet files found.
          </p>
        }
        @if (selectedFile) {
          <button
            mat-raised-button
            color="accent"
            (click)="importSelectedFile()"
            [disabled]="isImporting"
            class="import-file-button"
            >
            <mat-icon>file_upload</mat-icon>
            Import Selected File
          </button>
        }
      </div>

      <!-- Import Result Section -->
      @if (importResult) {
        <div class="import-result">
          <div class="result-header">
            <h3>Import Result</h3>
            <button mat-icon-button (click)="clearResult()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="result-content">
            @if (importResult.fileName) {
              <div class="result-item">
                <strong>File:</strong> {{ importResult.fileName }}
              </div>
            }
            <div class="result-item">
              <strong>Imported:</strong> {{ importResult.importedCount }}
            </div>
            <div class="result-item">
              <strong>Skipped:</strong> {{ importResult.skippedCount }}
            </div>
            <div class="result-item">
              <strong>Failed:</strong> {{ importResult.failedCount }}
            </div>
          </div>
        </div>
      }

      <!-- Loading Indicator -->
      @if (isImporting) {
        <div class="importing-overlay">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Importing data... This may take a few minutes.</p>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
